var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.90982 0 1.43036 2.47947 0 6C1.43036 9.52053 4.90982 12 9 12C13.0902 12 16.5696 9.52053 18 6C16.5696 2.47947 13.0902 0 9 0ZM9 10.5C6.52456 10.5 4.5 8.47567 4.5 6C4.5 3.52433 6.52456 1.5 9 1.5C11.4754 1.5 13.5 3.52433 13.5 6C13.5 8.47567 11.4754 10.5 9 10.5ZM9 3.75C7.76268 3.75 6.75 4.76325 6.75 6C6.75 7.23675 7.76268 8.25 9 8.25C10.2373 8.25 11.25 7.23675 11.25 6C11.25 4.76325 10.2373 3.75 9 3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b89d8baed9f8a455d7554b2c38fe66fa.svg";
export { ForwardRef as ReactComponent };